import React from "react";

const ContactUs = () => {
  return (
    <div className="bg-[#4A627C] text-white">
      <div className="mx-auto max-w-6xl  md:p-10 p-3 space-y-3">
        <div>
          <p className="text-white font-bold text-lg md:text-xl ">Contact Us</p>
        </div>
        <div className="bg-sdbodywhite h-0.5 w-10"></div>
        <div className="space-y-3 text-sm md:text-base">
          <p>
            Enrol Today: Contact the Executive Education Development Team to
            discuss enrolling yourself, your staff, or your organisation.
          </p>
          <p className="text-white">
            Email:
            <span className="text-[#EBCECE] ml-2">
              ee@sapphirediplomacy.com
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
